import { useCallback, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { twMerge } from "tailwind-merge";

import { faAngleDoubleDown } from "@fortawesome/free-solid-svg-icons/faAngleDoubleDown";
import { faAngleDoubleLeft } from "@fortawesome/free-solid-svg-icons/faAngleDoubleLeft";
import { faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons/faAngleDoubleRight";
import { faAngleDoubleUp } from "@fortawesome/free-solid-svg-icons/faAngleDoubleUp";

import FontAwesomeIcon from "components/FontAwesomeIcon";

import style from "./style.module.scss";

type TextMoreProps = {
  text: string;
  limit?: number;
  tooltip?: boolean;
  tooltipDelay?: number;
  verticalArrow?: boolean;
  className?: string;
  type?: "default" | "v2";
};

const TextMore = ({
  text,
  limit = Number.MIN_SAFE_INTEGER,
  tooltip,
  tooltipDelay = 200,
  verticalArrow,
  className,
  type = "default",
}: TextMoreProps) => {
  const shouldTruncate = text?.length > limit;
  const [showMore, toggleShowMore] = useState(!tooltip && type !== "v2");

  const handleTextToggle = useCallback(() => {
    toggleShowMore((isShowMore) => {
      return !isShowMore;
    });
  }, []);

  if (!shouldTruncate) {
    return <p className={style.description}>{text}</p>;
  }

  const truncatedText = text.slice(0, limit) + "...";

  if (type === "v2") {
    return (
      <>
        <div
          className={twMerge(
            "ml-[58px] mr-0 pr-0",
            showMore ? "" : "truncate",
            "text-intelligent-silver",
            className
          )}
        >
          {text}
          {showMore && (
            <span
              className="text-smart-teal ml-[5px] cursor-pointer"
              onClick={handleTextToggle}
            >
              less
            </span>
          )}
        </div>
        {!showMore && (
          <span
            className={twMerge(
              "text-smart-teal ml-[5px] cursor-pointer",
              className
            )}
            onClick={handleTextToggle}
          >
            more
          </span>
        )}
      </>
    );
  }

  if (tooltip) {
    return (
      <>
        <div
          className={twMerge(
            "ml-[58px] mr-0 pr-0",
            "overflow-hidden whitespace-nowrap text-clip",
            "text-intelligent-silver"
          )}
        >
          {text}
        </div>
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip>{text}</Tooltip>}
          delay={tooltipDelay}
        >
          <div className="text-smart-teal ml-[5px] cursor-pointer">more</div>
        </OverlayTrigger>
      </>
    );
  }

  return (
    <p className={style.description}>
      {showMore ? truncatedText : text}&nbsp;
      <button className={style.link_text} onClick={handleTextToggle}>
        {showMore ? "more " : "less "}
        <FontAwesomeIcon
          icon={
            showMore
              ? verticalArrow
                ? faAngleDoubleDown
                : faAngleDoubleRight
              : verticalArrow
              ? faAngleDoubleUp
              : faAngleDoubleLeft
          }
          rotation={90}
        />
      </button>
    </p>
  );
};

export default TextMore;
